module.exports = __webpack_public_path__ + "static/media/Template - End regular-site prices.6c9cd19e.csv";